<template>
  <div class="fixed inset-x-0 z-50">
    <component :is="component" :menu="menu" :phone="phone">
      <template v-slot:logo>
        <slot name="logo"></slot>
      </template>
      <template v-slot:icons>
        <slot name="icons"></slot>
      </template>
    </component>
  </div>
</template>
<script>
import TheNavBarMobile from './TheNavBarMobile.vue'
import TheNavBarDesktop from './TheNavBarDesktop.vue'

export default {
  data() {
    return {
      menu: jsonFromPage('#data-navbar-menu'),
    }
  },

  props: ['phone'],

  computed: {
    component() {
      return this.$mq.lg ? TheNavBarDesktop : TheNavBarMobile
    }
  }
}
</script>
